import { useState } from 'react';
import { isPushConfigured, subscribeToPush } from '../../lib/pushNotifications';

export default function PushOptIn() {
  const [status, setStatus] = useState<'idle' | 'working' | 'done' | 'error'>('idle');
  const [message, setMessage] = useState('');

  if (!isPushConfigured || status === 'done') return null;

  async function enable() {
    setStatus('working');
    setMessage('');
    try {
      await subscribeToPush();
      setStatus('done');
    } catch (error) {
      setStatus('error');
      setMessage(error instanceof Error ? error.message : 'تعذر تفعيل الإشعارات.');
    }
  }

  return (
    <div className="fixed bottom-4 left-4 z-40 max-w-[280px]" dir="rtl">
      <button onClick={enable} disabled={status === 'working'} className="w-full rounded-2xl border border-[#F5A623]/40 bg-[#1d1d1d]/95 backdrop-blur px-4 py-3 text-right shadow-2xl disabled:opacity-60">
        <div className="flex items-center gap-3"><div className="w-10 h-10 rounded-xl bg-[#F5A623] text-black grid place-items-center shrink-0"><i className="ri-notification-3-line text-xl" /></div><div><p className="text-sm font-bold text-white">فعّل إشعارات الموقع</p><p className="text-[11px] text-gray-400 mt-1">حتى توصلك التحديثات حتى والموقع مو مفتوح.</p></div></div>
        {message && <p className="text-[11px] text-red-300 mt-2">{message}</p>}
      </button>
    </div>
  );
}
